module.exports = "/cyber/_next/static/images/winners-determination-bg-mobile-98e2e49a8cb540f3ea6448155be6f19c.jpg";